import { Site } from '@envato/foundation-types'

export const siteAbbreviations = {
  [Site.themeforest]: 'tf',
  [Site.codecanyon]: 'cc',
  [Site.videohive]: 'vh',
  [Site.audiojungle]: 'aj',
  [Site.graphicriver]: 'gr',
  [Site.photodune]: 'pd',
  [Site.threedocean]: '3d'
}
